import { useEffect, useState } from "react";
import client from "@/api/client";

export function useSitesMap() {
  const [sites, setSites] = useState([]);
  const [siteMap, setSiteMap] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    client
      .get("/site-master/sites", { params: { all: true } })
      .then((res) => {
        if (!active) return;
        setSites(res.data);
        const map = {};
        res.data.forEach((s) => {
          if (s.site_id) map[s.site_id] = s.display_label || s.label;
        });
        setSiteMap(map);
      })
      .catch(() => {})
      .finally(() => active && setLoading(false));
    return () => {
      active = false;
    };
  }, []);

  return { sites, siteMap, loading };
}
